import { Pipe, PipeTransform } from '@angular/core';
import { formatCurrency, getCurrencySymbol } from '@angular/common';

@Pipe({
  name: 'oxioCurrency',
})
export class OxioCurrencyPipe implements PipeTransform {
  transform(
    value: number,
    hideDecimal: boolean = false,
    currencyCode: string = 'USD',
    display: 'code' | 'symbol' | string | boolean = 'symbol',
    digitsInfo: string = '1.0-0',
    locale: string = 'en-US'
  ): string | null {
    if (value === 0 || value) {
      if (!hideDecimal) {
        digitsInfo = undefined;
      }

      return formatCurrency(
        value,
        locale,
        getCurrencySymbol(currencyCode, 'wide'),
        currencyCode,
        digitsInfo
      );
    } else {
      return;
    }
  }
}
